module.exports = __webpack_public_path__ + "fonts/2ee208465857f5bf639a19d26543a42d.txt";